import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  roles: [],
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchRolesSuccess(state, action) {
      state.roles = action.payload;
    },
  },
});

export default slice.reducer;

export function changePassword({ password, confirmPassword, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`change-password`, {
        password,
        confirmPassword,
      });
      enqueueSnackbar("password is changed successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function changePasswordOfOthers({
  password,
  confirmPassword,
  enqueueSnackbar,
  user_id,
  setOpenEdit,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`change-password`, {
        user_id,
        password,
        confirmPassword,
      });
      setOpenEdit(false);

      enqueueSnackbar("password is changed successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRoles({ enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await axios.get(`roles`);

      dispatch(slice.actions.fetchRolesSuccess(res.data.data));
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
